<template>
  <div>
    <button
      @click="downloadList"
      :class="['button flex py-2 text-white bg-theme-1 zoom-in', classname]"
    >
      <Icon :name="'download'" :classname="'w-4 h-4 mr-2'" />
      {{ text }}
    </button>
    <a
      ref="download_planning"
      target="_blank"
      rel="noopener noreferrer nofollow"
      class="hidden"
      >{{ text }}</a
    >
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import axios from '@/services/axios'
import Icon from '@/components/admin/partials/Icon'

export default {
  props: {
    text: {
      type: String,
      default: 'Descargar Lista',
    },
    classname: '',
  },
  methods: {
    downloadList() {
      axios.get('planning/excel').then((response) => {
        const { data } = response
        const { path } = data

        this.$refs.download_planning.href = path
        this.$refs.download_planning.click()
      })
    },
    ...mapActions(['get']),
  },
  components: {
    Icon,
  },
}
</script>



// WEBPACK FOOTER //
// PlanningDownloadListButton.vue?2ce4847c